import $ from 'jquery';

/**
 * Login modal
 */
export default class LoginModal {
    /**
     * @param $modal Login modal
     * @param options Additional options
     */
    constructor($modal, options = {}) {
        this.options = $.extend(true, {
            classes: {
                button: 'navigation__external'
            },
        }, options);

        if (!$modal) {
            return;
        }

        this.$modal = $modal;
        this.$button = document.querySelector('.' + this.options.classes.button);

        this.init();
    }

    init() {
        this.eventHandler();
    }

    eventHandler() {
        const handlerToggle = (e) => {
            this.$modal.classList.toggle('login-modal--toggle');
        }

        this.$button.addEventListener('click', handlerToggle);
    }
}


// WEBPACK FOOTER //
// ./front/treasurybond/js/common/login-modal.js